<template>
    <div class="container" style="margin-top: 10px;">
        <h2>Mis mesas de regalo</h2>
        <vue-good-table :columns="columns" :rows="rows" :paginate="true" :lineNumbers="true"
            :search-options="{ enabled: true }" :pagination-options="{
                enabled: true,
                perPage: 5,
                perPageDropdown: [5, 10, 20],
                nextLabel: 'Siguiente',
                prevLabel: 'Anterior',
                rowsPerPageLabel: 'Filas por página',
                ofLabel: 'de',
                allLabel: 'Todo'
            }">
            <template #table-row="props">
                <span v-if="props.column.field === 'imgEvent'">
                    <img :src="`https://beauvoyage.net/storage/${props.row.imgEvent}`" alt="Imagen del evento"
                        style="width: 80px; height: 80px; object-fit: cover; border-radius: 6px;" />
                </span>
                <span v-if="props.column.field === 'acciones'">
                    <div class="d-grid gap-2">
                        <button class="btn btn-primary text-light" @click="borrarMesa(props.row.id)"
                            type="button">Borrar <i class="fa-solid fa-trash"></i></button>
                        <button class="btn btn-info text-light" @click="compartirMesa(props.row.id)" type="button">Compartir <i
                                class="fa-solid fa-share"></i></button>

                        <button type="button" class="btn btn-secondary text-light" @click="traerMesa(props.row.id)"
                            data-bs-toggle="modal" data-bs-target="#modalId">
                            Editar <i class="fa-solid fa-pen"></i>
                        </button>

                    </div>
                </span>
            </template>
        </vue-good-table>
    </div>

    <!-- Modal Body -->
    <!-- if you want to close by clicking outside the modal, delete the last endpoint:data-bs-backdrop and data-bs-keyboard -->
    <div class="modal fade" id="modalId" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false" role="dialog"
        aria-labelledby="modalTitleId" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="modalTitleId">
                        Editar mesa de regalo
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <form id="formEvento">
                        <div class="row g-3">
                            <!-- ID (solo lectura) -->

                            <!-- Tipo Evento -->
                            <div class="col-md-6">
                                <label for="tipoEvento" class="form-label">Tipo Evento</label>
                                <input type="text" id="tipoEvento" class="form-control" v-model="form.tipoEvento">
                            </div>

                            <!-- Tipo Admin -->
                            <!-- Nombre -->
                            <div class="col-md-6">
                                <label for="nombre" class="form-label">Nombre</label>
                                <input type="text" id="nombre" class="form-control" v-model="form.nombre">
                            </div>

                            <!-- Apellido Paterno -->
                            <div class="col-md-6">
                                <label for="aPaterno" class="form-label">Apellido Paterno</label>
                                <input type="text" id="aPaterno" class="form-control" v-model="form.aPaterno">
                            </div>

                            <!-- Apellido Materno -->
                            <div class="col-md-6">
                                <label for="aMaterno" class="form-label">Apellido Materno</label>
                                <input type="text" id="aMaterno" class="form-control" v-model="form.aMaterno">
                            </div>

                            <!-- Fecha Nacimiento -->
                            <div class="col-md-6">
                                <label for="fNacimiento" class="form-label">Fecha Nacimiento</label>
                                <input type="date" id="fNacimiento" class="form-control" v-model="form.fNacimiento">
                            </div>

                            <!-- Móvil -->
                            <div class="col-md-6">
                                <label for="movil" class="form-label">Móvil</label>
                                <input type="text" id="movil" class="form-control" v-model="form.movil">
                            </div>

                            <!-- ID User -->

                            <!-- Fecha Evento -->
                            <div class="col-md-6">
                                <label for="fEvento" class="form-label">Fecha Evento</label>
                                <input type="datetime-local" id="fEvento" class="form-control" v-model="form.fEvento">
                            </div>

                            <!-- Imagen -->
                            <!--  <div class="col-md-12">
                                <label for="imgEvent" class="form-label">Imagen</label>
                                <input type="text" id="imgEvent" class="form-control" v-model="form.imgEvent">
                            </div> -->
                            <!-- Acumulado -->
                            <div class="col-md-6">
                                <label for="acumulado" class="form-label">Acumulado</label>
                                <input type="number" id="acumulado" class="form-control" v-model="form.acumulado">
                            </div>

                            <!-- Correo -->
                            <div class="col-md-12">
                                <label for="correo" class="form-label">Correo</label>
                                <input type="email" id="correo" class="form-control" v-model="form.correo">
                            </div>

                            <!-- ID Viaje -->

                        </div>

                        <!-- Botón -->
                        <div class="mt-4 text-end">
                            <button type="button" class="btn btn-success" @click="actualizarMesa">Guardar
                                Cambios</button>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    </div>
    <div class="modal fade" id="modalContribuyentes" tabindex="-1" aria-labelledby="modalContribuyentesLabel"
        aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="modalContribuyentesLabel">Modal title</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    ...
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary">Save changes</button>
                </div>
            </div>
        </div>
    </div>


</template>
<script>
import axios from "axios"
import { VueGoodTable } from "vue-good-table-next"
import Swal from "sweetalert2";
export default {
    name: "GifsTableUser",
    data() {
        return {
            idUser: null,
            columns: [
                { label: "Aprovado", field: "tipoAdmin", type: "number" },
                { label: "Tipo Evento", field: "tipoEvento" },
                { label: "Nombre", field: "nombre" },
                { label: "Apellido Paterno", field: "aPaterno" },
                { label: "Apellido Materno", field: "aMaterno" },
                { label: "Móvil", field: "movil" },
                { label: "Fecha Evento", field: "fEvento" },
                { label: "Imagen", field: "imgEvent" },
                { label: "Correo", field: "correo" },
                { label: "Acciones", field: "acciones" }
            ],
            rows: [],
            form: {
                id: 5,
                tipoEvento: "boda",
                tipoAdmin: "0",
                nombre: "sfsdfsd",
                aPaterno: "fdsfsdfdsfds",
                aMaterno: "dfsfdsfds",
                fNacimiento: "2025-09-09",
                movil: "4343242",
                idUser: 2,
                fEvento: "2025-09-24T00:00", // para input datetime-local
                imgEvent: "eventos/i4WlZbtqSqt9WU0pd2GbtS00sNVoY5yu9FY95Kln.jpg",
                correo: "vcxvcxvcxv@cvcxvx",
                idViaje: 14,
                acumulado: 0
            },
        };
    },
    components: {
        VueGoodTable
    },
    methods: {
        async fetchData() {
            try {
                const response = await axios.get("https://beauvoyage.net/api/misMesas", {
                    params: { idUser: this.idUser }
                });
                this.rows = response.data;
                console.log(this.rows);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        },
        async getDataUser() {
            const token = localStorage.getItem("token")

            try {
                const response = await axios.get("https://beauvoyage.net/api/v1/auth/me", {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                this.idUser = response.data.id;
                this.fetchData(this.idUser);


            } catch (error) {
                console.log(error);
            }
        },
        async traerMesa(id) {
            const token = localStorage.getItem("token")
            try {
                const response = await axios.get("https://beauvoyage.net/api/VerMesa/" + id, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                console.log(response.data);
                this.form = response.data;
            } catch (error) {
                console.log(error);
            }
        },
        async actualizarMesa() {
            const token = localStorage.getItem("token")
            try {
                const res = await axios.post("https://beauvoyage.net/api/actulizarMesa", this.form, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                console.log(res.data);
                Swal.fire({
                    icon: 'success',
                    title: 'Mesa actualizada',
                    text: 'La mesa de regalos ha sido actualizada exitosamente.',
                    confirmButtonText: 'Aceptar'
                });
                this.fetchData();
            } catch (err) {
                console.error(err.response?.data || err);
            }
        },
        async borrarMesa(id) {
            const token = localStorage.getItem("token")
            try {
                const res = await axios.delete("https://beauvoyage.net/api/borrarMesa", {
                    data: { id: id },
                    headers: { Authorization: `Bearer ${token}` },
                });
                console.log(res.data);
                Swal.fire({
                    icon: 'success',
                    title: 'Mesa eliminada',
                    text: 'La mesa de regalos ha sido eliminada exitosamente.',
                    confirmButtonText: 'Aceptar'
                });
                this.fetchData();
            } catch (err) {
                console.error(err.response?.data || err);
            }
        },
        compartirMesa(id) {
            if (!id) return;

            const enlace = `http://localhost:8080/MesaRegalos?id=${id}`;

            // Copiar al portapapeles
            navigator.clipboard.writeText(enlace)
                .then(() => {
                    alert(`¡Enlace copiado! ${enlace}`);
                })
                .catch(() => {
                    alert("No se pudo copiar el enlace");
                });

            // O abrir en una nueva pestaña (opcional)
            // window.open(enlace, "_blank");
        }
    },
    mounted() {
        this.getDataUser();
    }
};
</script>